function AnalysisSpatialMatchesTrack() {
    "use strict";
    this.DeviceId = '';
    this.EnrolleeId = -1;
    this.TrackDate = '';
    this.TrackDateUTC = '';
    this.TrackTypeId = -1;
    this.Latitude = '';
    this.Longitude = '';
    this.DeviceSerialNumber = '- unknown -';
    this.GroupId = -1;
    this.Type = 1;
}
if (typeof exports !== 'undefined') {
    module.exports = AnalysisSpatialMatchesTrack;
}